import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { fetchData } from '../../helpers/methods';

import AiButtonRate from '../buttons/ai-button-rate';

const AiRating = ({
	feedbackKey,
}) => {
	const [thumbUpActive, setThumbUpActive] = useState(false);
	const [thumbDownActive, setThumbDownActive] = useState(false);
	const [disableButtons, setDisableButtons] = useState(false);

	const handleRate = rating => {
		setDisableButtons(true);
		const uri = `/api/web/feedbacks/${feedbackKey}/${rating}`;
		fetchData({
			uri,
			method: 'POST',
		})
			.then(({ ok }) => {
				if (ok) {
					if (rating === 'up') {
						setThumbUpActive(true);
					} else {
						setThumbDownActive(true);
					}
				} else {
					setDisableButtons(false);
				}
			})
			.catch(() => {
				setDisableButtons(false);
			});
	};

	return (
		<div className="ignite-ai__rating-container flex-row justify-flex-start">
			<AiButtonRate
				action={type => handleRate(type)}
				active={thumbUpActive}
				rateType="up"
				disabled={disableButtons}
			/>
			<AiButtonRate
				action={type => handleRate(type)}
				active={thumbDownActive}
				rateType="down"
				disabled={disableButtons}
			/>
		</div>
	);
};

export default AiRating;

AiRating.propTypes = {
	feedbackKey: PropTypes.string.isRequired,
};
